import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { DataAnalytics } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/data-analytics")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <DataAnalytics />
    </RouteGuard>
  ),
});
